module.exports = __webpack_public_path__ + "assets/img/mecha-detail-btn-5e23d73c.png";